module.exports = {"here":{"id":"2SmbapxcSQaHJ0S2ZpTI","code":"hLRz5-bZNNWxc_ys8jwERg"}}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 493
// module chunks = 0